// Doküman yükleme ekranları için ortak yardımcılar:
//  - eksikAlanlar: göndermeden önce eksik / hatalı alanları tek mesajda toplar
//  - yuklemeHataMesaji: sunucudan gelen hatayı kullanıcıya anlaşılır metne çevirir
// Sunucudaki sınırlarla aynı tutulmalı (backend helpers/multer.js).

export const DOSYA_MAX_MB = 50;
const IZINLI_UZANTILAR = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".xlsm", ".ppt", ".pptx", ".txt", ".csv", ".jpg", ".jpeg", ".png", ".gif", ".webp", ".heic", ".heif", ".bmp", ".tif", ".tiff", ".odt", ".ods", ".odp", ".rtf", ".msg", ".eml"];

const ALAN_ADLARI = {
  title: "Başlık",
  description: "Açıklama",
  excel: "Dosya",
  file: "Dosya",
  userId: "Kullanıcı bilgisi",
  updatedId: "Güncellenecek belge",
  category: "Kategori",
  reminder: "Hatırlatma bilgileri",
  "reminder.startDate": "Hatırlatma başlangıç tarihi",
  "reminder.endDate": "Hatırlatma bitiş tarihi",
  "reminder.notifyBefore": "Kaç gün önce bildirileceği",
};

const uzantiOf = (ad = "") => {
  const i = ad.lastIndexOf(".");
  return i >= 0 ? ad.slice(i).toLowerCase() : "";
};

/**
 * Formu göndermeden önce kontrol eder. Sorun yoksa null, varsa popup'ta gösterilecek tek bir metin döner.
 * doc: { title, file, reminderActive, startDate, endDate, notifyBefore }
 */
export const eksikAlanlar = (doc = {}, { dosyaZorunlu = true } = {}) => {
  const eksik = [];
  if (!String(doc.title || "").trim()) eksik.push("Başlık");
  if (dosyaZorunlu && !doc.file) eksik.push("Dosya");
  if (doc.reminderActive) {
    if (!doc.startDate) eksik.push("Hatırlatma başlangıç tarihi");
    if (!doc.endDate) eksik.push("Hatırlatma bitiş tarihi");
  }
  const sorunlar = [];
  if (eksik.length) sorunlar.push(`Eksik alanlar: ${eksik.join(", ")}.`);
  if (doc.reminderActive && doc.startDate && doc.endDate && new Date(doc.endDate) < new Date(doc.startDate)) {
    sorunlar.push("Hatırlatma bitiş tarihi başlangıç tarihinden önce olamaz.");
  }
  if (doc.file) {
    const uzanti = uzantiOf(doc.file.name);
    if (!IZINLI_UZANTILAR.includes(uzanti)) {
      sorunlar.push(`Bu dosya türü yüklenemez (${uzanti || "uzantısız"}). PDF, Word, Excel, PowerPoint, resim, TXT veya CSV seçin.`);
    }
    if (doc.file.size > DOSYA_MAX_MB * 1024 * 1024) {
      sorunlar.push(`Dosya çok büyük (${(doc.file.size / 1024 / 1024).toFixed(1)} MB). En fazla ${DOSYA_MAX_MB} MB yüklenebilir.`);
    }
    if (doc.file.size === 0) sorunlar.push("Seçilen dosya boş (0 bayt).");
  }
  return sorunlar.length ? sorunlar.join(" ") : null;
};

/** Sunucu / ağ hatasını kullanıcıya gösterilecek metne çevirir. */
export const yuklemeHataMesaji = (err) => {
  const r = err?.response;
  if (!r) {
    return "Sunucuya ulaşılamadı ya da bağlantı yarıda kesildi. İnternet bağlantınızı kontrol edip tekrar deneyin; dosya büyükse daha küçük bir dosyayla deneyin.";
  }
  const d = r.data || {};
  if (r.status === 413) return d.msg || `Dosya çok büyük. En fazla ${DOSYA_MAX_MB} MB yüklenebilir.`;
  if (r.status === 401) return "Oturumunuzun süresi dolmuş. Lütfen tekrar giriş yapın.";
  if (r.status === 403) return "Bu işlem için yetkiniz yok.";
  if (d.errorCode === 1000 && d.detail) {
    const alanlar = String(d.detail)
      .split(",")
      .map((a) => a.trim())
      .filter(Boolean)
      .map((a) => ALAN_ADLARI[a] || a);
    return `Eksik veya hatalı alan: ${alanlar.join(", ")}.`;
  }
  if (r.status >= 500) return "Sunucu hatası oluştu. Lütfen tekrar deneyin; sorun sürerse sistem yöneticisine bildirin.";
  return d.msg || d.message || "İşlem tamamlanamadı.";
};
